/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_Select_PageInputs */

const cs_settings_meta_select_page = /** @type {(inputs: Settings_Meta_Select_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte Facebook stránku`)
};

const en_settings_meta_select_page = /** @type {(inputs: Settings_Meta_Select_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Facebook Page`)
};

/**
* | output |
* | --- |
* | "Select Facebook Page" |
*
* @param {Settings_Meta_Select_PageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_select_page = /** @type {((inputs?: Settings_Meta_Select_PageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_Select_PageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_select_page(inputs)
	return cs_settings_meta_select_page(inputs)
});